module.exports = __webpack_public_path__ + "static/img/packaged-heavy-oil-residue_256.cd3de68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-heavy-oil-residue_256.png
// module id = +Ewe
// module chunks = 0